// Validator
/**
 * Checks if an input is empty. null, undefined, empty strings,
 * qualify as empty
 * @param {*} x item to be checked for emptiness
 * @returns {boolean} true if item is empty; otherwise, false
 */
export const isEmpty = x => {
  if (x === undefined || x === null || x === "") {
    return true;
  }
};

/**
 * Converts money string to 2 decimal places. E.g. 45.7499999 becomes 45.75
 * @param {string} money
 * @returns {object} null if money can't be converted.
 */
export function formatMoney(money) {
  return !isEmpty(money) ? money.toFixed(2) : null;
}
// export function round(num) {
//   return Number(Math.ceil(num * 100) / 100).toFixed(2);
// }



// WEBPACK FOOTER //
// ./src/util/index.js